import { useLocation } from 'react-router-dom'
import { useLayoutEffect } from 'react'

// This hook is required to scroll the page into a given hash found in url
// It's supposed to work out of the box in any browser but in our case won't.
// This is because most of the time the element with the target id has not been rendered yet,
// maybe we are doing data fetching on page load and the browser will not find the
// target element on first render. So we can use this hook to manually scroll the page
// by passing a condition
// Example: `useLocationHash(!isLoading)`
export const useLocationHash = (isReady: boolean) => {
  const { hash } = useLocation() // #target-hash

  useLayoutEffect(() => {
    if (hash && isReady) {
      const targetId = hash.replace('#', '')
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.scrollIntoView()
      }
    }
  }, [hash, isReady])
}
